import PropTypes from 'prop-types';
import { useReducer } from 'react';

import { inboxPreviewReducer, InboxPreviewContext, initialState } from './InboxPreviewContext';
import InboxPreviewPurchasePanel from './InboxPreviewPurchasePanel';

const InboxPreviewPurchasePanelWithContext = ({ customer }) => {
  const inboxPreviewState = useReducer(inboxPreviewReducer, initialState);

  return (
    <InboxPreviewContext.Provider value={inboxPreviewState}>
      <InboxPreviewPurchasePanel customer={customer} />
    </InboxPreviewContext.Provider>
  );
};

InboxPreviewPurchasePanelWithContext.propTypes = {
  customer: PropTypes.shape({
    getCountryCode: PropTypes.func,
  }),
};

export default InboxPreviewPurchasePanelWithContext;
